module.exports = __webpack_public_path__ + "img/gms_12.5fdf5f9c.png";